import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "stats-wrapper d-flex flex-items-center" }
const _hoisted_3 = { class: "stats-value" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dots-vertical" }, null, -1)
const _hoisted_5 = { class: "d-flex flex-items-center p-3" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.team !== null && _ctx.team !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "tabs-subtitle level-bg d-flex flex-justify-center flex-items-center",
          style: _normalizeStyle(_ctx.getBarStyle(_ctx.config))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
              }, _toDisplayString(_ctx.formatNumber(_ctx.team.instagramFanCount + _ctx.team.facebookFanCount + _ctx.team.twitterFanCount + _ctx.team.tiktokFanCount)), 5),
              _createElementVNode("h6", {
                style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
              }, "obserwujących", 4)
            ])
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_ctx.team.avatar !== null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "img-circle img-50",
                  src: _ctx.team.avatar.url
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("h1", {
              class: "ml-3",
              style: _normalizeStyle(_ctx.getTextColor(_ctx.config))
            }, _toDisplayString(_ctx.team.name), 5)
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}